import script from "./thematicFunds.vue?vue&type=script&setup=true&lang=js"
export * from "./thematicFunds.vue?vue&type=script&setup=true&lang=js"

import "./thematicFunds.vue?vue&type=style&index=0&id=16177bbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16177bbf"]])

export default __exports__